import script from "./outbound-count-ranking-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./outbound-count-ranking-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__